import React from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import ClearStyledButton from "@/components/ui/clear_styled_button";
import { Body, Link, SectionHeader } from "@sprout/typography";
import ClearModalHeader from "@/components/ui/clear_modal_header";
import IdCardIcon from "@sprout/icons/id_card";
import SmartphoneIcon from "@sprout/icons/smartphone";
import useTranslation from "@hooks/use_translation";
import { TertiaryButton } from "@sprout/buttons";

interface ClearVerificationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onVerify: () => void;
  companyName: string;
}

const ClearVerificationModal: React.FC<ClearVerificationModalProps> = ({
  isOpen,
  onClose,
  onVerify,
}) => {
  const { t } = useTranslation("clear_verification");
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent
        onOpenAutoFocus={(e: Event) => e.preventDefault()}
        className="sm:max-w-xl p-6 rounded-lg max-h-[90vh] overflow-y-auto"
      >
        <ClearModalHeader />

        <div className="mb-6">
          <SectionHeader className="!mb-4">{t("modal.title")}</SectionHeader>

          <Body className="text-base !mb-8">{t("modal.intro_html")}</Body>

          <div className="space-y-4 mb-4">
            <div className="flex items-center px-3">
              <span className="mr-3">
                <SmartphoneIcon size="md" />
              </span>
              <Body className="text-base">{t("modal.requirements.phone")}</Body>
            </div>

            <div className="flex items-center px-3">
              <span className="mr-3">
                <IdCardIcon size="md" />
              </span>
              <Body className="text-base">{t("modal.requirements.id")}</Body>
            </div>
          </div>

          <Body className="text-base">
            {t("modal.privacy_html")} {""}
            <Link href="https://support.greenhouse.io/hc/en-us/articles/40497797083419" external>
              {t("modal.learn_more")}
            </Link>
          </Body>
        </div>

        <div className="flex flex-col items-center gap-3 mx-auto">
          <ClearStyledButton onClick={onVerify} />
          <TertiaryButton onClick={onClose}>{t("modal.not_now")}</TertiaryButton>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ClearVerificationModal;
